import $ from "jquery";
import CONFIG from "@bd-core/config";

export default class Timer {
    constructor(timeoutCallback) {
        this.timeoutCursor = null;
        this.timeoutCallback = timeoutCallback;
        this.hintPenaltySeconds = 0; 
        this.elms = {
            timer: ".js-timer-text",
        };
    }

    init() {
        // Don't run this on static page
        if (!CONFIG.game.cfgLimit || !CONFIG.game.start_at) return false;

        let self = this;

        if (this.timeoutCursor) {
            clearInterval(this.timeoutCursor);
        }

        const getCurrentTime = () => new Date(Date.now()).getTime();
        const startTime = CONFIG.game.start_at * 1000;
        const cfgLimit = CONFIG.game.cfgLimit.timeLimit * 60 * 1000;
        const elapsedTime = getCurrentTime() - startTime + (this.hintPenaltySeconds * 1000);
        const toTimeObject = (time) => {
            const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((time / 1000 / 60) % 60);
            const seconds = Math.floor((time / 1000) % 60);

            return {
                h: hours.toString().padStart(2, "0"),
                m: minutes.toString().padStart(2, "0"),
                s: seconds.toString().padStart(2, "0"),
            };
        };

        const updateTimer = (h, m, s) => {
            const txtH = h !== "00" ? `${h}:` : "";
            let txtTimer = `${txtH}${m}:${s}`;

            $(self.elms.timer).text(txtTimer);
        };

        // Check if game has exceeded time limit
        if (elapsedTime >= cfgLimit) {
            const objTime = toTimeObject(cfgLimit);
            updateTimer(objTime.h, objTime.m, objTime.s);
            return false;
        }

        if (CONFIG.game.isFinish || CONFIG.game?.game_prop?.disableTimer) {
            const objTime = toTimeObject(elapsedTime);

            updateTimer(objTime.h, objTime.m, objTime.s);

            return false;
        }

        this.timeoutCursor = setInterval(() => {
            const currentElapsedTime = getCurrentTime() - startTime + (this.hintPenaltySeconds * 1000);
            const objTimer = toTimeObject(currentElapsedTime);

            $.each(CONFIG.game.cfgLimit.notifications, function (index, item) {
                // Convert notification time from minutes to milliseconds
                const notificationTime = item.inMinutesLeft * 60 * 1000;
                const notificationElapsedTime = cfgLimit - notificationTime;
                
                const hours = Math.floor(notificationElapsedTime / (1000 * 60 * 60));
                const minutes = Math.floor((notificationElapsedTime % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((notificationElapsedTime % (1000 * 60)) / 1000);

                if (
                    objTimer.h == hours.toString().padStart(2, "0") &&
                    objTimer.m == minutes.toString().padStart(2, "0") &&
                    objTimer.s == seconds.toString().padStart(2, "0")
                ) {
                    CONFIG.game.cfgLimit.notifications.splice(index, 1);
                    return false;
                }
            });

            updateTimer(objTimer.h, objTimer.m, objTimer.s);

            if (currentElapsedTime >= cfgLimit) {
                if (self.timeoutCursor) {
                    clearInterval(self.timeoutCursor);
                }

                if (typeof self.timeoutCallback == "function")
                    self.timeoutCallback();
            }
        }, 1000);

        // Perform timer calculation immediately before the interval
        const initialElapsedTime = getCurrentTime() - startTime + (this.hintPenaltySeconds * 1000);
        const objTimer = toTimeObject(initialElapsedTime);
        updateTimer(objTimer.h, objTimer.m, objTimer.s);

        return this;
    }

    stopTimer() {
        if (CONFIG.game.isFinish) {
            clearInterval(this.timeoutCursor);
        }
    }

    /**
     * Add hint penalty (1 minute = 60 seconds)
     */
    addHintPenalty() {
        this.hintPenaltySeconds += 60;

        if (this.timeoutCursor) {
            clearInterval(this.timeoutCursor);
            this.init();
        }
    }

    /**
     * Remove hint penalty (1 minute = 60 seconds)
     */
    removeHintPenalty() {
        this.hintPenaltySeconds = Math.max(0, this.hintPenaltySeconds - 60);

        if (this.timeoutCursor) {
            clearInterval(this.timeoutCursor);
            this.init();
        }
    }

    /**
     * Get current hint penalty in seconds
     */
    getHintPenalty() {
        return this.hintPenaltySeconds;
    }
}
